import styled from "@emotion/styled";
import { PaperAProps } from "@src/ruix/types";

const PaperA = (props: PaperAProps) => {
	const { variant, bgColor } = props;
	const order = props.order || "row";
	const fullWidth = props.fullWidth ? "full-width" : "";
	const fullHeight = props.fullHeight ? "full-height" : "";
	const radius = props.radius || 10;

	const px = props.px !== undefined ? props.px : 30;
	const py = props.py !== undefined ? props.py : 20;
	const gap = props.gap !== undefined ? props.gap : 4;

	return (
		<PaperAComponent
			style={{
				padding: `${py}px ${px}px`,
				gap: `${gap}px`,
				backgroundColor: bgColor ? bgColor : undefined,
			}}
			radius={radius}
			className={[variant, order, fullWidth, fullHeight].join(" ")}
		>
			{props.children}
		</PaperAComponent>
	);
};

const PaperAComponent = styled.div`
	display: flex;
	border-radius: ${({ radius }: { radius: number }) => radius}px;

	&.--bg-white {
		background-color: white;
		color: var(--card-bg);
		border: 1px solid rgba(0, 0, 0, 0.02);
		box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);
	}

	&.white {
		background-color: white;
		color: black;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
	}

	&.dark {
		background-color: var(--bg);
		color: white;
	}

	&.primary {
		background-color: var(--primary);
		color: white;
	}

	&.secondary {
		background-color: var(--secondary);
		color: white;
	}

	&.gray {
		background-color: var(--gray-daken);
		color: white;
	}

	&.bg-gray {
		background-color: #202020;
		color: white;
	}

	&.transparent {
		background-color: transparent;
	}

	&.full-width {
		width: 100%;
	}
	&.full-height {
		height: 100%;
	}
`;

export default PaperA;
